/** 
 * Object of all the route's path
 */
const routesPath = {
    root: '/',
    comingSoon: '/comingsoon',
    pageNotFound: '/page-not-found',
    profileMyprofile: '/profile/myprofile',
    profileChangepassword: '/profile/changepassword',
    userManagement: '/User/UserManagement',
    // userManagementWithId: function(id){ return `${ this.userManagement }/${ id }` },
    groups: '/groups',
    groupInfoWithId: function(id = ':id'){ return `/groupinfo/${ id }` },
    broadcast: '/broadcast',
    manageBroadcast: '/broadcast/manage',
    broadcastTeam: '/broadcast/team',
    broadcastTeamAdd: '/broadcast/team/addteam',
    broadcastTeamEdit: function(id = ':id'){ return `/broadcast/team/editteam/${ id }` },
    manageAdmin: '/admin/manageadmin',
    manageAdminRoles: '/admin/manageadminroles',
    feedback: '/feedback',
    help: '/help',
    settings: '/settings',
    callManagement: '/callmanagement',
    appAccessControl: '/appaccesscontrol',
    report: '/reports',
    detailReport: '/reports/:id'
}

export default routesPath;